@if (toasts().length > 0) {
  <div class="alert-stack">
    @for (toast of toasts(); track toast.id) {
      <div
        class="alert-box"
        [attr.role]="role(toast)"
        [ngClass]="getCssClass(toast)"
        (mouseenter)="notify.pause(toast.id)"
        (mouseleave)="notify.resume(toast.id)"
        (focusin)="notify.pause(toast.id)"
        (focusout)="notify.resume(toast.id)"
        >
        <div class="alert-text">
          <div class="alert-message">{{ toast.message }}</div>
          @if (toast.reference) {
            <div class="alert-reference">{{ 'common.reference' | translate: { id: toast.reference } }}</div>
          }
        </div>
        @if (toast.action) {
          <button class="action-btn" (click)="onActionClick(toast)">{{ toast.action.label }}</button>
        }
        <button class="close-btn" (click)="notify.dismiss(toast.id)" [attr.aria-label]="'a11y.close' | translate">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true">
            <path d="M6 6l12 12M18 6L6 18" />
          </svg>
        </button>
        @if (!toast.sticky) {
          <div class="progress-bar" [style.width.%]="progress(toast)"></div>
        }
      </div>
    }
  </div>
}
